export default "/images/96c35620804843b5242bc6ba3888ddd1.avif";